/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Dashboard components
import StudentDashboard from "./student.js";
import ParentDashboard from "./parent.js";
import AdminDashboard from "./admin.js";
import { useUser } from "../../context/api.js";

function Dashboard() {
  const user = useUser();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {user.type === "student" && <StudentDashboard />}
      {user.type === "parent" && <ParentDashboard />}
      {user.type === "admin" && <AdminDashboard />}
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
